<template>
<div class="row">
    <div class="col-md-6">
        <APIList :api_keys="api_keys" :users="users" :isLoaded="isLoaded" />

        <ul class="pagination pagination-sm m-0 float-right">
          <li class="page-item">
            <a class="page-link" href="#" @click.prevent="previousPage">Previous</a>
          </li>
          <li class="page-item">
            <a class="page-link">{{ currentPage }} / {{ pageCount }}</a>
          </li>
          <li class="page-item">
            <a class="page-link" href="#" @click.prevent="nextPage">Next</a>
          </li>
        </ul>
    </div>

    <div class="col-md-6">
        <APIView :api_key="api_key" :users="users" :permissions="permissions" :isLoading="isLoading" @updateList="updateList" @refreshList="refreshList"/>
    </div>
</div>
</template>

<script>
import APIList from '@/components/api/List'
import APIView from '@/components/api/API'

import { RepositoryFactory } from '@/services/repositories/ManagementAPI/RepositoryFactory' 
const APIRepo = RepositoryFactory.get('local_apis')
const UsersRepo = RepositoryFactory.get('users')

const PermissionsRepo = RepositoryFactory.get('permissions')

export default {
    name: "API_Keys",
    components: {
        APIList,
        APIView
    },
    data: function() {
        return {
            permissions: [],
            users: [],

            api_keys: [],
            api_key: {
                name: "",
                status: ""
            },
            
            isLoaded: false,
            isLoading: false,

            currentPage: 1,
            totalRecords: 0,
            resultsLimit: 10,
            isLoaded: false,
        }
    },
    created() {
        this.loadAPIKeys()
        this.loadPermissions()
        this.loadUsers()
    },
    methods: {
        loadPermissions: function() {
            PermissionsRepo.all().then(result => {
                this.permissions = result.data.results
            })
        },
        loadUsers: function() {
            UsersRepo.all().then(result => {
                this.users = result.data.results
            })
        },
        loadAPIKeys: function() {
            this.isLoaded = false
            APIRepo.page(this.currentPage).then(result => {
                this.totalRecords = result.data.count
                this.api_keys = result.data.results
                this.isLoaded = true
            }).catch(err => {})
        },
        loadAPIKey: function(id) {
            this.isLoading = true
            APIRepo.get(id).then(result => {
                this.api_key = result.data
                this.isLoading = false
            }).catch(err => {})
        },
        updateList: function(api_key) {
            this.api_keys.push(api_key)
            this.$router.replace({params: {'id': api_key.id}})
        },
        refreshList: function(action) {
            if(action)
                this.loadAPIKeys()
        },
        nextPage: function() {
            if(this.currentPage != this.pageCount || this.currentPage > this.pageCount) {
                this.currentPage = this.currentPage + 1
                this.loadAPIKeys()
            }
        },
        previousPage: function() {
            if(this.currentPage != 1 ) {
                this.currentPage = this.currentPage - 1
                this.loadAPIKeys()
            }
        }
    },
    computed: {
        pageCount: function() {
            return Math.ceil(this.totalRecords / this.resultsLimit)
        },
        apiList: function() {
            return this.api_list
        }
    },
    watch: {
        '$route.params.id': {
            handler: function (id) {
                if(typeof id !== 'undefined') {
                    this.loadAPIKey(id)
                }
            },
            deep: true,
            immediate: true
        },
    }
}
</script>

<style>

</style>